import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';

import {
  CheckPromoDisplayOfferParams,
  CheckPromoDisplayOfferResponse,
  checkPromoDisplayOffer,
} from '~/services/PromoService';

export type CheckPromoDisplayParams = CheckPromoDisplayOfferParams;
export type CheckPromoDisplayResponse = CheckPromoDisplayOfferResponse;

export function usePromoDisplayCheck() {
  const { enqueueSnackbar } = useSnackbar();
  const brand = useSelector((state: App.State) => state.tenant.brand);

  const checkPromoDisplayMutation = useMutation({
    mutationFn: async (params: CheckPromoDisplayParams) => {
      return await checkPromoDisplayOffer({
        ...params,
        brand: params.brand || brand || 'luxuryescapes',
      });
    },
    onSuccess: (response: CheckPromoDisplayResponse) => {
      enqueueSnackbar(response.message, { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error checking promo display: ${error.message}`, { variant: 'error' });
    },
  });

  return {
    checkPromoDisplay: checkPromoDisplayMutation.mutate,
    checkPromoDisplayAsync: checkPromoDisplayMutation.mutateAsync,
    isChecking: checkPromoDisplayMutation.isPending,
    error: checkPromoDisplayMutation.error,
    data: checkPromoDisplayMutation.data,
  };
}
